/**
 * Country options for the ICP country picker.
 * Grouped under the same 6 geographic buckets used by REGION_OPTIONS so a
 * country selection can always be rolled up to a region for fit scoring.
 */

export const COUNTRY_GROUPS = [
  {
    category: "North America",
    options: ["United States", "Canada", "Mexico", "Puerto Rico", "Bermuda"],
  },
  {
    category: "Europe",
    options: [
      "United Kingdom", "Ireland", "Germany", "France", "Netherlands", "Belgium", "Luxembourg",
      "Spain", "Portugal", "Italy", "Switzerland", "Austria", "Denmark", "Sweden", "Norway",
      "Finland", "Iceland", "Poland", "Czech Republic", "Slovakia", "Hungary", "Romania",
      "Bulgaria", "Greece", "Croatia", "Slovenia", "Serbia", "Estonia", "Latvia", "Lithuania",
      "Ukraine", "Cyprus", "Malta", "Monaco",
    ],
  },
  {
    category: "Asia Pacific",
    options: [
      "Australia", "New Zealand", "Japan", "South Korea", "China", "Hong Kong", "Taiwan",
      "Singapore", "Malaysia", "Indonesia", "Thailand", "Vietnam", "Philippines", "India",
      "Pakistan", "Bangladesh", "Sri Lanka", "Nepal", "Cambodia", "Mongolia", "Kazakhstan",
    ],
  },
  {
    category: "Latin America",
    options: [
      "Brazil", "Argentina", "Chile", "Colombia", "Peru", "Uruguay", "Paraguay", "Bolivia",
      "Ecuador", "Venezuela", "Costa Rica", "Panama", "Guatemala", "Honduras", "El Salvador",
      "Nicaragua", "Dominican Republic", "Jamaica", "Trinidad and Tobago",
    ],
  },
  {
    category: "Middle East",
    options: [
      "United Arab Emirates", "Saudi Arabia", "Qatar", "Kuwait", "Bahrain", "Oman",
      "Israel", "Turkey", "Jordan", "Lebanon", "Iraq",
    ],
  },
  {
    category: "Africa",
    options: [
      "South Africa", "Nigeria", "Kenya", "Egypt", "Morocco", "Ghana", "Tunisia", "Algeria",
      "Ethiopia", "Tanzania", "Uganda", "Rwanda", "Senegal", "Côte d'Ivoire", "Botswana",
      "Namibia", "Zambia", "Mauritius",
    ],
  },
];

export const ALL_COUNTRIES = COUNTRY_GROUPS.flatMap(g => g.options);

// country → region lookup, used to roll countries up for region-level scoring.
export const COUNTRY_TO_REGION = COUNTRY_GROUPS.reduce((acc, g) => {
  g.options.forEach(c => { acc[c] = g.category; });
  return acc;
}, {});

export const regionsForCountries = (countries = []) =>
  [...new Set(countries.map(c => COUNTRY_TO_REGION[c]).filter(Boolean))];
